import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box } from "@chakra-ui/react";
import { cdnURL } from "@inspire/util/cdn";
var PageHero = function(param) {
    var bgImage = param.bgImage, boxProps = param.boxProps, children = param.children;
    return /*#__PURE__*/ _jsxs(Box, {
        minHeight: [
            280,
            310
        ],
        position: "relative",
        display: "flex",
        children: [
            /*#__PURE__*/ _jsx(Box, {
                bgImage: cdnURL(bgImage),
                bgPosition: "center",
                bgRepeat: "no-repeat",
                bgSize: "cover",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                _after: {
                    backgroundColor: "rgba(0,0,0,.6)",
                    content: '" "',
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    boxShadow: "inset 0 0 0 1px hsl(0deg 0% 100% / 15%)",
                    border: "1px solid rgba(0,0,0,.15)"
                }
            }),
            /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
                zIndex: 1,
                flex: 1,
                display: "flex",
                flexDir: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                p: [
                    4,
                    12
                ]
            }, boxProps), {
                children: children
            }))
        ]
    });
};
export default PageHero;
